import React, { useRef } from 'react';
import useDictation from '../../hooks/useDictation';

function TextareaConDictado({ value, onChange, placeholder, disabled, rows = 5 }) {
  const valueRef = useRef(value);
  valueRef.current = value;

  const dictado = useDictation((text) => {
    const current = valueRef.current;
    onChange((current ? current + ' ' : '') + text.trim());
  });

  return (
    <div className="dictado-textarea-wrapper">
      <textarea
        className="form-textarea"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        rows={rows}
      />
      {!disabled && (
        <button
          type="button"
          className={`dictado-mic-btn${dictado.grabando ? ' dictado-mic-btn--grabando' : ''}`}
          onClick={dictado.grabando ? dictado.detener : dictado.iniciar}
          disabled={dictado.procesando}
          title={dictado.grabando ? 'Detener dictado' : 'Dictado por voz'}
          aria-label={dictado.grabando ? 'Detener dictado' : 'Activar dictado por voz'}
        >
          <i className={`fas ${dictado.procesando ? 'fa-spinner fa-spin' : dictado.grabando ? 'fa-stop' : 'fa-microphone'}`} />
        </button>
      )}
    </div>
  );
}

export default TextareaConDictado;
